import { render, staticRenderFns } from "./Mitgliederstatistik.vue?vue&type=template&id=1413d88e&"
import script from "./Mitgliederstatistik.vue?vue&type=script&lang=js&"
export * from "./Mitgliederstatistik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports